module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"uso":"Uso","absorcion_agua":"Absorción agua","tipo_ceramico":"Tipo material cerámico","tipo_producto":"Tipo de producto","ceramico":"Cerámico","no-ceramico":"No cerámico","publico":"Público","privado":"Privado","publico_propio":"Público propio","filtros":"Filtros"}}')
  delete Component.options._Ctor
}
